// src/layouts/IndividualCompLayout.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, Copy } from 'lucide-react';
import MinimalLogo from '@/components/ui/MinimalLogo';
import { Button } from '@components/ui/button.jsx';
import { useModal } from '@/contexts/ModalContext';
import { useCompetition } from '@/contexts/CompetitionContext';
import AvatarMenu from '@/components/ui/AvatarMenu';
import { useTenant } from '@/contexts/TenantContext';

const IndividualCompLayout = ({ children, onParticipate }) => {
  const { openModal } = useModal();
  const { competition } = useCompetition();
  const [copied, setCopied] = useState(false);
const { branding, tenant } = useTenant();

  const handleShare = async () => {
    const url = `${window.location.origin}/competition/${competition?.id}`;

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // Fallback for browsers that block clipboard API
      const el = document.createElement('textarea');
      el.value = url;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen w-full bg-stone-brown text-swan">

      {/* Top Navigation Bar */}
      <header className="fixed top-0 left-0 w-full z-50 flex items-center justify-between px-6 py-3 shadow-md bg-stone-brown">

        {/* Logo */}
       <Link to="/competitions" className="flex items-center gap-3">
          {branding?.logo_url ? (
            <>
              <img
                src={branding.logo_url}
                alt={tenant?.name ?? 'Partner'}
                className="h-8 w-auto object-contain rounded"
              />
            </>
          ) : (
            <MinimalLogo className="h-10" />
          )}
        </Link>

        {/* Right Actions */}
        <div className="flex items-center gap-4">

          {/* Share Button */}
          <Button
            variant="primary"
            size="sm"
            onClick={handleShare}
            className="flex items-center gap-1.5 transition-all"
          >
            {copied ? (
              <>
                <Check size={14} />
                Copied!
              </>
            ) : (
              <>
                <Copy size={14} />
                Share!
              </>
            )}
          </Button>

       {/* Participate Button */}
          {competition?.competition_state === 'live' && (
            <Button
              variant="primary"
              size="sm"
              onClick={onParticipate}
            >
              Participate!
            </Button>
          )}

          {/* Avatar */}
          <AvatarMenu />
        </div>
      </header>

      {/* Main Content */}
      <main className="overflow-y-auto h-[calc(100dvh)] px-6">
        {children}
      </main>
    </div>
  );
};

export default IndividualCompLayout;